import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import Disclaimer from '../Disclaimer';
import { view01ImageOptions } from './views/view01'

class Deck extends Component {
    constructor(props) {
        super(props);

        this.handleDeckChange = this.handleDeckChange.bind(this);
        this.handleTeakOnSideDecksChange = this.handleTeakOnSideDecksChange.bind(this);
        this.handleTeakOnCoachroofChange = this.handleTeakOnCoachroofChange.bind(this);
        this.handleTeakOnBathingPlatformChange = this.handleTeakOnBathingPlatformChange.bind(this);
      
    }



    handleDeckChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Deck = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnSideDecksChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnSideDecks = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };
        
        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnBathingPlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnBathingPlatform = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBathingPlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.BathingPlatform = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    handleTeakOnCoachroofChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnCoachroof = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }


    render() {
        let imageOptions = view01ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Deck & cockpit' /></h1>
                    <p><Trans defaults='Standard on the X4<sup>3</sup> is teak on cockpit floor and seats. The teak is with black caulkings, and optional is Flexiteek finish with grey stripes.' /></p>

                    <RadioGroup label={this.props.t("Deck material:")} options={this.props.deckOptions} value={this.props.configuration.Deck} onChange={this.handleDeckChange} />

                    <p>
                        <img style={{ border: '1px solid #c2c2c2', width: '50%' }} src={this.props.configuration.Deck.preview} alt='Deck material' />
                    </p>

                    <h3><Trans defaults='Deck options:' /></h3>

                    <Toggle checked={this.props.configuration.TeakOnSideDecks.value === 2} onChange={this.handleTeakOnSideDecksChange}>
                        <Trans defaults='{{wood}} on side decks' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>
                    <Toggle checked={this.props.configuration.TeakOnCoachroof.value === 2} onChange={this.handleTeakOnCoachroofChange}>
                        <Trans defaults='{{wood}} on coachroof' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>


                    <Disclaimer />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Deck);


// WEBPACK FOOTER //
// ./src/X43MK2/Deck.js